import Reveal from './Reveal';
import { CheckCircle, Terminal } from 'lucide-react';

const WhyImago = () => {
    const benefits = [
        "Team collaboration built-in",
        "Dark & light mode support",
        "Import from Postman & OpenAPI",
        "Export results to Excel",
        "Test localhost via secure local agent",
        "Environment & collection variables"
    ];

    return (
        <section className="py-20 sm:py-28 relative overflow-hidden">
            <div className="absolute inset-0 pointer-events-none">
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[400px] bg-cyan-500/5 blur-[150px] rounded-full" />
                <div className="absolute bottom-0 right-0 w-[400px] h-[300px] bg-purple-500/5 blur-[120px] rounded-full" />
            </div>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                <div className="text-center mb-12 sm:mb-16">
                    <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-emerald-500/10 border border-emerald-500/20 text-emerald-400 text-xs font-mono mb-6 sm:mb-8">
                        <Terminal className="w-3.5 h-3.5" />
                        Why Imago
                    </div>
                    <Reveal>
                        <h2 className="text-2xl sm:text-3xl md:text-5xl font-extrabold text-white tracking-tight mb-4 sm:mb-6">
                            Why Developers Choose{' '}
                            <span className="bg-gradient-to-r from-cyan-400 to-emerald-400 bg-clip-text text-transparent">Imago</span>
                        </h2>
                        <p className="text-base sm:text-lg text-gray-500 max-w-3xl mx-auto">
                            Built for speed, reliability, and developer experience. Stop wrestling with clunky tools and start testing efficiently.
                        </p>
                    </Reveal>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
                    {benefits.map((benefit, index) => (
                        <Reveal key={index} delay={index * 80} className="h-full">
                            <div className="h-full flex items-center gap-3 bg-[#111111] p-4 sm:p-5 rounded-xl border border-white/5 hover:border-emerald-500/20 transition-all duration-500 group">
                                <div className="w-8 h-8 rounded-md bg-emerald-500/10 border border-emerald-500/20 flex items-center justify-center text-emerald-400 flex-shrink-0 group-hover:scale-110 transition-transform">
                                    <CheckCircle className="w-4 h-4" />
                                </div>
                                <span className="text-sm sm:text-base font-medium text-gray-300 font-mono">{benefit}</span>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default WhyImago;
